module.exports = __webpack_public_path__ + "img/рз_17.aaf80fa4.png";